// @flow
import React, { Component, Fragment } from "react";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ErrorsType } from "../../types/UserFormType";
import {
  SingleTextField,
  StyledTextField,
  StyledSelect,
  CancelButton,
  SubmitButton,
  ButtonSelect,
  SingleCheckBox,
  UploadButton
} from "imagus-components";
import {
  ErrosDisplay,
  setErrorMsg,
  WarningDisplay,
  checkPositiveInteger
} from "../../containers/ErrosDisplay";
import ChipInput from "../../../global/components/ChipInput";
import {
  JsDateObjectDisplayDateOnly,
  StartDatetoEndDate,
  DateDiff,
  DatabaseDateToJsDateISOString
} from "../../../global/functions/DateTimeAmend";
import CompanyNameReminder from "../../components/companies/CompanyNameReminder";
import InfiniteCalendarSelect from "../../../global/components/InfiniteCalendarSelect";
import KeyValuePairsInput from "./KeyValuePairsInput";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme: *): * => ({
  button: {
    display: "inline-flex"
  },
  chip: {
    verticalAlign: "-50%"
  }
});

const DefaultModules = (licenceType?: string): * => {
  const modules = [
    { name: "face_recognition_module", version: "1.0", data: "0", selected: true },
    { name: "gender_module", version: "1.0", data: "", selected: true },
    { name: "age_module", version: "1.0", data: "", selected: true },
    { name: "streams", version: "1.0", data: "", selected: true }
  ];

  if (licenceType === "DEMO") {
    modules.push({ name: "demographics", version: "1.0", data: "3", selected: true });
  }

  return modules;
};

type CreateLicenceFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  facebase_id: string,
  camera_count: string,
  device_count: string,
  face_count: string,
  auto_assign: boolean,
  start_date: Date | null,
  expiry_date: Date | null,
  type: string,
  years: string,
  days: string,
  isNewSystem: boolean,
  person_limit: string,
  online: boolean,
  facebase_name: string,
  current_person_limit: string,
  po_file: File | null,
  model: string,
  modules: Array<*>
};

type CreateLicenceFormPropsType = {
  facebases: Array<*>,
  licence?: { [key: string]: * },
  isEdit?: boolean,
  LicenceTypes: Array<*>,
  createLicence: Function,
  updateLicence: Function,
  onClose: Function,
  openSnackbar: Function,
  canChangeModel: boolean,
  modelList: Array<*>,
  classes: { [key: string]: * }
};

const initialform: CreateLicenceFormStatesType = {
  errors: {},
  loading: false,
  facebase_id: "",
  camera_count: "",
  device_count: "",
  face_count: "",
  auto_assign: false,
  start_date: null,
  expiry_date: null,
  type: "",
  years: "",
  days: "",
  isNewSystem: true,
  person_limit: "",
  online: false,
  facebase_name: "",
  current_person_limit: "",
  po_file: null,
  model: "",
  modules: []
};

class CreateLicenceForm extends Component<
  CreateLicenceFormPropsType,
  CreateLicenceFormStatesType
> {
  constructor(props: CreateLicenceFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  componentDidMount() {
    const initials = { ...initialform };
    if (this.props.isEdit && this.props.licence) {
      const licence = this.props.licence;
      initials.type = licence.licenceType;
      initials.start_date = DatabaseDateToJsDateISOString(
        licence.startDateOrigin
      );
      initials.expiry_date = DatabaseDateToJsDateISOString(
        licence.expiryDateOrigin
      );
      initials.camera_count = licence.noOfStreams;
      initials.device_count = licence.slotsTotal;
      initials.auto_assign = licence.autoAssign;
      initials.face_count = licence.facebaseLimit;

      if (licence.licenceType === "LONGTERM") {
        if (licence.extentDate) {
          initials.expiry_date = DatabaseDateToJsDateISOString(
            licence.extentDate
          );
        }

        let diff = 0;
        if (this.props.licence.authorisedReseller) {
          diff = 1;
        } else {
          diff = 1;
        }
        initials.years = String(
          DateDiff(
            licence.startDateOrigin,
            licence.extentDate ? licence.extentDate : licence.expiryDateOrigin,
            "years"
          ) - diff
        );
      } else if (licence.licenceType === "SHORTTERM") {
        initials.days = String(
          DateDiff(licence.startDateOrigin, licence.expiryDateOrigin, "days")
        );
      } else if (licence.licenceType === "DEMO") {
        initials.days = "30";
      } else if (licence.licenceType === "ONEYEAR") {
        initials.days = "365";
      }

      if (licence.poFile) {
        initials.po_file = { name: licence.poFile };
      }

      if (licence.modules) {
        let modules = [];
        licence.modules.map((module: *): * => {
          modules.push({
            name: module.name,
            version: module.version,
            data: module.data,
            selected: true
          });
        });
        initials.modules = modules;
      } else {
        initials.modules = DefaultModules();
      }
    } else {
      initials.model = this.props.modelList[0].value;
      initials.modules = DefaultModules();
    }
    this.setState({ ...initials, errors: {} });
  }

  handleTextChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    let value = e.currentTarget.value;

    this.setState(
      {
        [name]: value
      },
      (): * => {
        if (name === "years" || name === "days") {
          if (isNaN(value)) {
            value = "";
            this.setState({
              errors: setErrorMsg(
                this.state.errors,
                "image",
                "Please Type a Number."
              )
            });
          } else {
            if (
              name === "years" &&
              (parseInt(value, 10) > 5 || parseInt(value, 10) < 0)
            ) {
              this.setState({
                errors: setErrorMsg(
                  this.state.errors,
                  "image",
                  "Standard Licence additional years maximum is 5 years."
                )
              });
            } else if (name === "days" && parseInt(value, 10) < 10) {
              this.setState({
                errors: setErrorMsg(
                  this.state.errors,
                  "image",
                  "Short Term Licence minimum is 10 days."
                )
              });
            } else {
              this.setState({
                errors: setErrorMsg(this.state.errors, "image", "", true)
              });
            }
          }

          this.setExpiryDate();
        }
        if (name === "device_count") {
          this.checkDeviceLimit(value);
        }
        if (name === "person_limit" || name === "face_count") {
          this.setState({
            errors: checkPositiveInteger(this.state.errors, value)
          });
        }
      }
    );
  };

  checkDeviceLimit = (value: string): * => {
    if (this.props.isEdit && value.trim() !== "") {
      let prevCount = Number(this.props.licence.slotsTotal);
      if (Number(value) < prevCount) {
        this.setState({
          errors: setErrorMsg(
            this.state.errors,
            "tags",
            "You can only INCREASE number of devices."
          )
        });
      } else {
        this.setState({
          errors: setErrorMsg(this.state.errors, "tags", "", true)
        });
      }
    }
  };

  syncChange = (name: string, value: Array<*>) => {
    this.setState(
      { [name]: value },
      (): * => {
        if (name === "facebase_id") {
          let index = this.props.facebases.findIndex((x) => x.value === value);
          const limit =
            index > -1 ? this.props.facebases[index].personLimit || "" : "";
          this.setState({ current_person_limit: limit });

          // Validate for DEMO licence
          if (this.state.type === "DEMO" && limit !== "" && Number(limit) > 500) {
            this.setState({
              errors: setErrorMsg(
                this.state.errors,
                "tags",
                "Demo licence only allows systems with 500 or fewer faces."
              )
            });
          } else {
            this.setState({
              errors: setErrorMsg(this.state.errors, "tags", "", true)
            });
          }
        }
      }
    );
  };

  handleCheckBoxChange = (
    e: Event & { currentTarget: HTMLInputElement }
  ): * => {
    this.setState({
      [e.currentTarget.name]: !this.state[e.currentTarget.name]
    });
  };

  syncDateChange = (name: string, date: Date): * => {
    this.setState({ [name]: date }, (): * => {
      if (name === "start_date") {
        this.setExpiryDate();
      } else {
        this.checkStartandExpiryDates();
      }
    });
  };

  handleTypeChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });

    if (name === "type") {
      if (value === "LONGTERM") {
        this.setState({ days: "", years: "0" }, (): * => {
          this.setExpiryDate();
          this.checkLicenceType();
        });
      } else if (value === "SHORTTERM") {
        this.setState({ years: "", days: "10" }, (): * => {
          this.setExpiryDate();
          this.checkLicenceType();
        });
      } else if (value === "DEMO") {
        this.setState(
          {
            years: "",
            days: "30",
            person_limit: "500",
            camera_count: "3",
            device_count: "2",
            modules: DefaultModules("DEMO"),
            facebase_id: "",
            current_person_limit: ""
          },
          (): * => {
            this.setExpiryDate();
            this.checkLicenceType();
          }
        );
      } else if (value === "ONEYEAR") {
        this.setState({ years: "", days: "365" }, (): * => {
          this.setExpiryDate();
          this.checkLicenceType();
        });
      } else if (value === "EVALUATION") {
        this.setState({ years: "", days: "" }, (): * => {
          this.setExpiryDate();
          this.checkLicenceType();
        });
      } else {
        this.setState({ years: "", days: "" }, (): * => {
          this.setExpiryDate();
          this.checkLicenceType();
        });
      }
    }
  };

  setExpiryDate = (): * => {
    let expiry_date = null;
    if (
      this.state.start_date &&
      (this.state.years !== "" || this.state.days !== "")
    ) {
      let diff;
      if (this.state.days) {
        diff = parseInt(this.state.days, 10);
      } else {
        diff = parseInt(this.state.years, 10) + 1;
      }
      expiry_date = StartDatetoEndDate(
        this.state.start_date,
        this.state.years !== "" ? "y" : "d",
        diff
      );
    } else {
      expiry_date = this.state.expiry_date;
    }
    this.setState({ expiry_date: expiry_date }, this.checkStartandExpiryDates);
  };

  checkLicenceType = (checkPo?: boolean = false): * => {
    if (this.state.type === "") {
      this.setState({
        errors: setErrorMsg(
          this.state.errors,
          "licence",
          "Please Select a Licence Type first."
        )
      });
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, "licence", "", true)
      });
      if (checkPo) {
        if (this.state.type === "LONGTERM" || this.state.type === "SHORTTERM") {
          if (this.state.po_file) {
            this.setState({
              errors: setErrorMsg(this.state.errors, "agree_check", "", true)
            });
          } else {
            this.setState({
              errors: setErrorMsg(
                this.state.errors,
                "agree_check",
                "Please Upload a PO file."
              )
            });
          }
        }
      }
    }
  };

  checkStartandExpiryDates = (): * => {
    if (this.state.start_date && this.state.expiry_date) {
      if (this.state.expiry_date <= this.state.start_date) {
        this.setState({
          errors: setErrorMsg(
            this.state.errors,
            "agree_check",
            "Expiry Date can not be less than Start Date."
          )
        });
      } else {
        this.setState({
          errors: setErrorMsg(this.state.errors, "agree_check", "", true)
        });
      }
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, "agree_check", "", true)
      });
    }
  };

  handleSwitch = (name: string, value: string): * => {
    this.setState({ [name]: value });
  };

  uploadFileHandler = (e: Event): * => {
    let file;
    if (e.dataTransfer) {
      file = e.dataTransfer.files[0];
    } else if (e.target) {
      file = e.target.files[0];
    }
    if (file) {
      this.setState({ po_file: file });
      this.setState({
        errors: setErrorMsg(this.state.errors, "agree_check", "", true)
      });
    }
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.checkLicenceType(true);
    if (Object.keys(this.state.errors).length === 0) {
      this.setState({ loading: true });

      let modules = null;
      if (this.props.canChangeModel) {
        modules = this.state.modules.filter(
          (module: *): * => module.selected && module.name.trim() !== ""
        );
      }

      if (this.props.isEdit) {
        this.props.updateLicence(
          this.props.licence.id,
          this.state.expiry_date,
          this.state.start_date,
          Number(this.state.device_count) -
          Number(this.props.licence.slotsTotal),
          this.state.auto_assign,
          this.state.type === "ONEYEAR" ? "EVALUATION" : this.state.type, //this is a hack to avoid adding enum value to DB
          this.state.camera_count,
          this.state.face_count,
          this.state.po_file &&
            this.state.po_file.name !== this.props.licence.poFile
            ? this.state.po_file
            : null,
          modules,
          this.submitDone,
          this.submitFail
        );
      } else {
        this.props.createLicence(
          this.state.isNewSystem,
          this.state.facebase_id,
          this.state.facebase_name,
          this.state.person_limit,
          this.state.online,
          this.state.type === "ONEYEAR" ? "EVALUATION" : this.state.type, //this is a hack to avoid adding enum value to DB
          this.state.years,
          this.state.days,
          this.state.auto_assign,
          this.state.start_date,
          this.state.expiry_date,
          this.state.device_count,
          this.state.camera_count,
          this.state.po_file,
          this.state.model,
          modules,
          this.submitDone,
          this.submitFail
        );
      }
    }
  };

  submitDone = () => {
    this.props.onClose();
    this.props.openSnackbar &&
      this.props.openSnackbar(this.props.isEdit ? 5 : 3);
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    const classes = this.props.classes;

    let graceText = "";
    if (this.state.type === "LONGTERM") {
      graceText = "*Standard Licence has a grace period of 14 days";
    } else if (this.state.type === "SHORTTERM") {
      graceText = "*Short Term Licence has a grace period of 3 days";
    }

    const DisabledCondition = this.state.type === "DEMO";

    if (this.props.LicenceTypes.length === 0) {
      return (
        <WarningDisplay
          warning="You can ONLY create licences for End-Users. Please choose an end-user to create the licence for it."
          display={true}
        />
      );
    } else {
      return (
        <form onSubmit={(!loading && this.submit) || undefined}>
          <Grid container spacing={8}>
            {!this.props.isEdit && (
              <Grid item xs={12} className="top-margin-10">
                <ButtonSelect
                  value={this.state.isNewSystem}
                  name="isNewSystem"
                  buttons={[
                    { label: "Create New System", value: true },
                    { label: "Use Existing System", value: false }
                  ]}
                  handleChange={this.handleSwitch}
                />
              </Grid>
            )}
            {/**------------------ Create for new system ---------------*/}
            {this.state.isNewSystem && !this.props.isEdit && (
              <Card style={{ width: "100%" }} className="top-margin-5">
                <CardContent>
                  <Typography variant="h6">New System</Typography>
                  <Grid container spacing={8}>
                    <Grid item xs={12} md={6}>
                      <StyledTextField
                        isRequired={true}
                        label="System Name"
                        name="facebase_name"
                        value={this.state.facebase_name}
                        onChange={this.handleTextChange}
                        inpuType="text"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <StyledTextField
                        isRequired={true}
                        label="Number of Faces in database"
                        name="person_limit"
                        value={this.state.person_limit}
                        onChange={this.handleTextChange}
                        inpuType="number"
                        isDisabled={DisabledCondition}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <SingleCheckBox
                        name="online"
                        value={this.state.online}
                        onChange={this.handleCheckBoxChange}
                        label="Enable Online Syncing (*additional charges may apply)"
                      />
                    </Grid>
                    {this.props.canChangeModel && (
                      <Grid item xs={12}>
                        <StyledSelect
                          value={this.state.model}
                          onChange={this.handleTypeChange}
                          name="model"
                          label="Model Version"
                          isRequired={true}
                          menus={this.props.modelList}
                          isStyled
                        />
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            )}

            {/**------------------ Create for existing system ---------------*/}
            {!this.state.isNewSystem && !this.props.isEdit && (
              <Card style={{ width: "100%" }} className="top-margin-5">
                <CardContent>
                  <Typography variant="h6">Existing System</Typography>
                  <Grid container spacing={8}>
                    <Grid item xs={12} md={6}>
                      <ChipInput
                        name="facebase_id"
                        label="Select System"
                        isStyled
                        isRequired
                        placeholder="Select a current System"
                        tags={
                          this.state.type === "DEMO"
                            ? this.props.facebases.filter(fb => Number(fb.personLimit) === 500)
                            : this.props.facebases
                        }
                        value={this.state.facebase_id}
                        syncChange={this.syncChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} className="top-margin-10">
                      <SingleTextField
                        isRequired={false}
                        label="Current Database Limit"
                        name="current_person_limit"
                        value={this.state.current_person_limit}
                        onChange={(): * => null}
                        inpuType="text"
                        isDisabled
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            {/**------------------ Edit a licence ---------------*/}
            {this.props.isEdit && (
              <Fragment>
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    isRequired={true}
                    label="Number of Faces in database"
                    name="face_count"
                    value={this.state.face_count}
                    onChange={this.handleTextChange}
                    inpuType="number"
                    isDisabled={DisabledCondition}
                  />
                </Grid>
                <Grid item xs={12} md={6} />
              </Fragment>
            )}
            {/** --------------End of header ----------------- */}
            {/** --------------Licence body ----------------- */}
            <Grid item xs={12} md={6}>
              <StyledSelect
                value={this.state.type}
                onChange={this.handleTypeChange}
                name="type"
                label="Licence Type"
                isRequired={true}
                menus={this.props.LicenceTypes}
                isInvalid={errors.licence !== undefined}
                isStyled
              />
            </Grid>
            <Grid item xs={12} md={6} className="top-margin-10">
              {this.state.type === "LONGTERM" && (
                <SingleTextField
                  isRequired={true}
                  label="Additional Services (Years)"
                  name="years"
                  value={this.state.years}
                  onChange={this.handleTextChange}
                  inpuType="number"
                  endAdornment={
                    <InputAdornment position="end">Years</InputAdornment>
                  }
                  isInvalid={errors.image !== undefined}
                  helper="Please specify a value from 0 to 5"
                />
              )}
              {this.state.type === "SHORTTERM" && (
                <SingleTextField
                  isRequired={true}
                  label="Choose How Many Days"
                  name="days"
                  value={this.state.days}
                  onChange={this.handleTextChange}
                  inpuType="number"
                  endAdornment={
                    <InputAdornment position="end">Days</InputAdornment>
                  }
                  isInvalid={errors.image !== undefined}
                  helper="Min 10 days"
                />
              )}
              {this.state.type === "DEMO" && (
                <div style={{ paddingTop: "25px" }}>
                  <CompanyNameReminder
                    label={"Demo Licence is 30 Days fixed."}
                  />
                  <input type="hidden" name="days" value="30" />
                </div>
              )}

              {/* {this.state.type === "ONEYEAR" && (
                <div style={{ paddingTop: "25px" }}>
                  <CompanyNameReminder
                    label={"One Year Licence will only valid for 1 year"}
                  />
                  <input type="hidden" name="days" value="365" />
                </div>
              )} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <InfiniteCalendarSelect
                isRequired={true}
                label="Licence Start Date"
                name="start_date"
                value={this.state.start_date}
                syncDateChange={this.syncDateChange}
                {...(!this.props.isEdit ? { min_date: new Date() } : {})}
              />
            </Grid>
            {(this.state.type === "EVALUATION" && (
              <Grid item xs={12} md={6}>
                <InfiniteCalendarSelect
                  isRequired={true}
                  label="Licence Expiry Date"
                  name="expiry_date"
                  value={this.state.expiry_date}
                  syncDateChange={this.syncDateChange}
                  {...(!this.props.isEdit ? { min_date: new Date() } : {})}
                  isEndDate
                />
              </Grid>
            )) || (
                <Grid item xs={12} md={6} className="top-margin-10">
                  <SingleTextField
                    isRequired={false}
                    label={
                      this.state.type === "LONGTERM"
                        ? "Maintenance Expiry Date"
                        : "Licence Expiry Date"
                    }
                    name="expiry_date"
                    value={
                      this.state.expiry_date
                        ? JsDateObjectDisplayDateOnly(this.state.expiry_date)
                        : ""
                    }
                    onChange={(): * => null}
                    inpuType="text"
                    isDisabled
                    helper={graceText}
                  />
                </Grid>
              )}
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={true}
                label="Number of Cameras/ Streams/ Channels"
                name="camera_count"
                value={this.state.camera_count}
                onChange={this.handleTextChange}
                inpuType="number"
                isDisabled={DisabledCondition}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                isRequired={true}
                label="Number of Servers"
                name="device_count"
                value={this.state.device_count}
                onChange={this.handleTextChange}
                inpuType="number"
                isDisabled={DisabledCondition}
                isInvalid={errors.tags !== undefined}
              />
            </Grid>
            {/*
          <Grid item xs={12} md={6}>
            <StyledSelect
              value={this.state.project_id}
              onChange={this.handleTypeChange}
              name="project_id"
              label="Select Linked Project"
              isRequired={false}
              menus={LicenceTypes}
              isInvalid={errors.company !== undefined}
              isStyled
            />
          </Grid>
          */}
            <Grid item xs={12} className="comment-top-margin-20">
              <SingleCheckBox
                name="auto_assign"
                value={this.state.auto_assign}
                onChange={this.handleCheckBoxChange}
                label="Auto Assign(tick this if issuing the licence for mobile)"
              />
            </Grid>
            {(this.state.type === "SHORTTERM" ||
              this.state.type === "LONGTERM") && (
                <Grid item xs={12}>
                  <UploadButton
                    id="po_file"
                    uploadFileActions={this.uploadFileHandler}
                    fileType=".pdf"
                    outerClass={classes.button}
                  />
                  {this.state.po_file && (
                    <Chip
                      label={this.state.po_file.name}
                      className={classes.chip + " left-margin-10"}
                    />
                  )}
                </Grid>
              )}
            {this.props.canChangeModel && (
              <Grid item xs={12}>
                <KeyValuePairsInput
                  label="Modules"
                  name="modules"
                  value={this.state.modules}
                  isRequired={false}
                  syncChange={this.syncChange}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <ErrosDisplay errors={errors} form="create licence" />
            </Grid>
            <Grid item xs={12}>
              <div className="form-right-btn-block">
                <CancelButton onClick={this.props.onClose} />
                <SubmitButton
                  loading={loading}
                  disabled={Object.keys(errors).length > 0}
                />
              </div>
            </Grid>
          </Grid>
        </form>
      );
    }
  }
}

export default withStyles(styles)(CreateLicenceForm);
